export enum LogEvent {
  ADAPTER_STATE_UPDATE = 'ADAPTER_STATE_UPDATE',
  ACS_SDK_START_INIT = 'ACS_SDK_START_INIT',
  ACS_SDK_START_INIT_ERROR = 'ACS_SDK_START_INIT_ERROR',
  ACS_SDK_CHATCLIENT_ERROR = 'ACS_SDK_CHATCLIENT_ERROR',
  ACS_SDK_JOINTHREAD_ERROR = 'ACS_SDK_JOINTHREAD_ERROR',
  ACS_SDK_CHATCLIENT_RECONNECT_ERROR = 'ACS_SDK_CHATCLIENT_RECONNECT_ERROR',
  ACS_ADAPTER_ATTACHMENT_DOWNLOADED = 'ACS_ADAPTER_ATTACHMENT_DOWNLOADED',
  ACS_ADAPTER_ATTACHMENT_DOWNLOAD_ERROR = 'ACS_ADAPTER_ATTACHMENT_DOWNLOAD_ERROR',
  ACS_ADAPTER_ATTACHMENT_NEW = 'ACS_ADAPTER_ATTACHMENT_NEW',
  ACS_ADAPTER_ATTACHMENT_ALREADY_DOWNLOADED = 'ACS_ADAPTER_ATTACHMENT_ALREADY_DOWNLOADED',
  ACS_ADAPTER_PROCESSED_ATTACHMENTS = 'ACS_ADAPTER_PROCESSED_ATTACHMENTS',
  ACS_ADAPTER_CONVERT_HISTORY = 'ACS_ADAPTER_CONVERT_HISTORY',
  ACS_ADAPTER_CONVERT_TYPING_MESSAGE = 'ACS_ADAPTER_CONVERT_TYPING_MESSAGE',
  ACS_ADAPTER_CONVERT_MESSAGE = 'ACS_ADAPTER_CONVERT_MESSAGE',
  ACS_ADAPTER_CONVERT_EDITED_MESSAGE = 'ACS_ADAPTER_CONVERT_EDITED_MESSAGE',
  ACS_ADAPTER_CONVERT_THREAD_UPDATED = 'ACS_ADAPTER_CONVERT_THREAD_UPDATED',
  ACS_ADAPTER_CONVERT_THREAD_DELETED = 'ACS_ADAPTER_CONVERT_THREAD_DELETED',
  ACS_ADAPTER_INGRESS_MESSAGE = 'ACS_ADAPTER_INGRESS_MESSAGE',
  ACS_ADAPTER_INGRESS_FAILED = 'ACS_ADAPTER_INGRESS_FAILED',
  ACS_ADAPTER_EGRESS_MESSAGE = 'ACS_ADAPTER_EGRESS_MESSAGE',
  ACS_ADAPTER_EGRESS_SEND_MESSAGE = 'ACS_ADAPTER_EGRESS_SEND_MESSAGE',
  ACS_ADAPTER_EGRESS_FAILED = 'ACS_ADAPTER_EGRESS_FAILED',
  ACS_ADAPTER_REQUEST_DOWNLOAD_ATTACHMENTS = 'ACS_ADAPTER_REQUEST_DOWNLOAD_ATTACHMENTS',
  ACS_ADAPTER_SEND_MESSAGE_FAILED = 'ACS_ADAPTER_SEND_MESSAGE_FAILED',
  ACS_ADAPTER_SEND_MESSAGE_SUCCESS = 'ACS_ADAPTER_SEND_MESSAGE_SUCCESS',
  ACS_ADAPTER_SEND_MESSAGE_RETRY = 'ACS_ADAPTER_SEND_MESSAGE_RETRY',
  ACS_ADAPTER_INGRESS_TYPING_FAILED = 'ACS_ADAPTER_INGRESS_TYPING_FAILED',
  ACS_ADAPTER_INGRESS_TYPING_SUCCESS = 'ACS_ADAPTER_INGRESS_TYPING_SUCCESS',
  ACS_ADAPTER_EGRESS_TYPING_SENDING_REQUEST = 'ACS_ADAPTER_EGRESS_TYPING_SENDING_REQUEST',
  ACS_ADAPTER_EGRESS_TYPING_FAILED = 'ACS_ADAPTER_EGRESS_TYPING_FAILED',
  ACS_ADAPTER_EGRESS_TYPING_SUCCESS = 'ACS_ADAPTER_EGRESS_TYPING_SUCCESS',
  ACS_ADAPTER_REALTIME_NOTIFICATION_CONNECTED = 'ACS_ADAPTER_REALTIME_NOTIFICATION_CONNECTED',
  ACS_ADAPTER_REALTIME_NOTIFICATION_DISCONNECTED = 'ACS_ADAPTER_REALTIME_NOTIFICATION_DISCONNECTED',
  ACS_PROCESSING_POLLED_MESSAGE = 'ACS_PROCESSING_POLLED_MESSAGE',
  ACS_PROCESSING_NEW_MESSAGE = 'ACS_PROCESSING_NEW_MESSAGE',
  ACS_PROCESSING_EDITED_MESSAGE = 'ACS_PROCESSING_EDITED_MESSAGE',
  ACS_SKIP_POLLED_MESSAGE = 'ACS_SKIP_POLLED_MESSAGE',
  ACS_CANCEL_POLLING_CALLBACK = 'ACS_CANCEL_POLLING_CALLBACK',
  ACS_CREATE_POLLING_CALLBACK = 'ACS_CREATE_POLLING_CALLBACK',
  ACS_ADAPTER_POLLING_STATUSCODE = 'ACS_ADAPTER_POLLING_STATUSCODE',
  ACS_SEND_POLLING_REQUEST = 'ACS_SEND_POLLING_REQUEST',
  ACS_ADAPTER_POLLING_SKIPPED = 'ACS_ADAPTER_POLLING_SKIPPED',
  ACS_ADAPTER_POLLING_STOPPED = 'ACS_ADAPTER_POLLING_STOPPED',
  ACS_SKIP_NEW_MESSAGE = 'ACS_SKIP_NEW_MESSAGE',
  ACS_SKIP_EDITED_MESSAGE = 'ACS_SKIP_EDITED_MESSAGE',
  ACS_ADAPTER_POST_ACTIVITY = 'ACS_ADAPTER_POST_ACTIVITY',
  ACS_ADAPTER_POST_FILE_ACTIVITY = 'ACS_ADAPTER_POST_FILE_ACTIVITY',
  ACS_SDK_RECONNECT = 'ACS_SDK_RECONNECT',
  MESSAGE_RECEIVED = 'ADAPTER_MESSAGE_RECEIVED',
  PROCESS_CACHED_PAGED_HISTORY_MESSAGE = 'PROCESS_CACHED_PAGED_HISTORY_MESSAGE', // Process cached paged history messages
  PROCESS_CACHED_HISTORY_MESSAGE = 'PROCESS_CACHED_HISTORY_MESSAGE', // Process cached polled history messages
  PROCESS_CACHED_NEW_MESSAGE = 'PROCESS_CACHED_NEW_MESSAGE', // Process cached new messages
  CACHE_PAGED_HISTORY_MESSAGE = 'CACHE_PAGED_HISTORY_MESSAGE', // Cache a paged history message before webchat init
  CACHE_POLLED_HISTORY_MESSAGE = 'CACHE_POLLED_HISTORY_MESSAGE', // Cache a polled history message before webchat init
  CACHE_NEW_MESSAGE = 'CACHE_NEW_MESSAGE', // Cache a new message before webchat init
  TYPING_MESSAGE_RECEIVED = 'ADAPTER_TYPING_MESSAGE_RECEIVED',
  THREAD_THREAD_UPDATED = 'ADAPTER_THREAD_UPDATED_RECEIVED',
  THREAD_DELETED_RECEIVED = 'ADAPTER_THREAD_DELETED_RECEIVED',
  PARTICIPANT_REMOVED_RECEIVED = 'ADAPTER_PARTICIPANT_REMOVED_RECEIVED',
  PARTICIPANT_ADDED_RECEIVED = 'ADAPTER_PARTICIPANT_ADDED_RECEIVED',
  MESSAGE_EDIT_RECEIVED = 'ADAPTER_MESSAGE_EDIT_RECEIVED',
  REGISTER_ON_NEW_MESSAGE = 'ADAPTER_REGISTER_ON_NEW_MESSAGE',
  REGISTER_ON_TYPING_INDICATOR = 'ADAPTER_REGISTER_ON_TYPING_INDICATOR',
  REGISTER_ON_MESSAGE_EDIT = 'ADAPTER_REGISTER_ON_MESSAGE_EDIT',
  REGISTER_ON_THREAD_DELETED = 'ADAPTER_REGISTER_ON_THREAD_DELETED',
  REGISTER_ON_THREAD_UPDATED = 'ADAPTER_REGISTER_ON_THREAD_UPDATED',
  REGISTER_ON_PARTICIPANT_ADDED = 'ADAPTER_REGISTER_ON_PARTICIPANT_ADDED',
  REGISTER_ON_PARTICIPANT_REMOVED = 'ADAPTER_REGISTER_ON_PARTICIPANT_REMOVED',
  REGISTER_ON_REALTIME_NOTIFICATION_CONNECTED = 'ADAPTER_REGISTER_ON_REALTIME_NOTIFICATION_CONNECTED',
  REGISTER_ON_REALTIME_NOTIFICATION_DISCONNECTED = 'ADAPTER_REGISTER_ON_REALTIME_NOTIFICATION_DISCONNECTED',
  NETWORK_ONLINE = 'NETWORK_ONLINE',
  NETWORK_OFFLINE = 'NETWORK_OFFLINE',
  FILEMANAGER_DOWNLOAD_FILE_FAILED = 'FILEMANAGER_DOWNLOAD_FILE_FAILED',
  FILEMANAGER_UPLOAD_FILE_FAILED = 'FILEMANAGER_UPLOAD_FILE_FAILED',
  FILEMANAGER_UPLOAD_FILE_REQUEST = 'FILEMANAGER_UPLOAD_FILE_REQUEST',
  WEBCHAT_SUBSCRIPTION_TIMEOUT = 'WEBCHAT_SUBSCRIPTION_TIMEOUT',
  WEBCHAT_SUBSCRIPTION_SUCCESS = 'WEBCHAT_SUBSCRIPTION_SUCCESS',
  WEBCHAT_STATUS_CONNECTED = 'WEBCHAT_STATUS_CONNECTED'
}
